"use client";

import React from "react";
import { Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="grid grid-cols-2 gap-x-8 gap-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/50 animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="grid grid-cols-2 gap-x-8 gap-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4">
        <Separator className="bg-white/10 mb-12" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 items-start">
          {}
          <div className="flex flex-col items-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/bchoops_logo_footer.png" alt="BCHOOPS" className="h-7" />
          </div>

          {}
          <div className="flex justify-start md:justify-center">
            <MenuProvider menu_id="17">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex justify-start md:justify-end gap-6">
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="Instagram">
              <Instagram className="size-6" />
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="YouTube">
              <Youtube className="size-6" />
            </Link>
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-mono text-muted-foreground/60 border-t border-white/5 pt-8">
          <p>&copy; {new Date().getFullYear()} BCHOOPS. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors duration-300">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}